module.exports = __webpack_public_path__ + "img/main04.ff9517a5.jpg";